import { render, staticRenderFns } from "./CanadasCasas.vue?vue&type=template&id=1ce5b34f"
import script from "./CanadasCasas.vue?vue&type=script&lang=js"
export * from "./CanadasCasas.vue?vue&type=script&lang=js"
import style0 from "./CanadasCasas.vue?vue&type=style&index=0&id=1ce5b34f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports